import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import SignupAccountVerificationChangeButtons from "./widget/SignupAccountVerificationChangeButtons";
import SignupAccountVerificationChangeContent from "./SignupAccountVerificationChangeContent";
import { SignupAccountVerificationContextProvider } from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const SignupAccountVerificationChangeScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <SignupAccountVerificationContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={<SignupAccountVerificationChangeButtons />}
      >
        <MainBodyContainer>
          <SignupAccountVerificationChangeContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SignupAccountVerificationContextProvider>
  );
};

export default SignupAccountVerificationChangeScreen;
export const routeName: string = "/signup/account-verification-change";
